import { render, staticRenderFns } from "./veStuSemesterShow.vue?vue&type=template&id=2476e192&scoped=true"
import script from "./veStuSemesterShow.vue?vue&type=script&lang=js"
export * from "./veStuSemesterShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476e192",
  null
  
)

export default component.exports